/**
 * Subtle parallax on article hero images.
 * Respects prefers-reduced-motion.
 */
class ArticleHero extends HTMLElement {
  connectedCallback() {
    this.parallaxEl = this.querySelector('[data-article-hero-parallax]');
    if (!this.parallaxEl) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.ticking = false;

    if (this.reduceMotion.matches) {
      this.parallaxEl.style.transform = 'translate3d(0, 0, 0) scale(1.05)';
      return;
    }

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.onScroll();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    if (!this.parallaxEl || this.reduceMotion.matches) return;

    const rect = this.getBoundingClientRect();
    const viewH = window.innerHeight || 1;

    // Skip work when far off-screen
    if (rect.bottom < -80 || rect.top > viewH + 80) return;

    // -1 when hero is below viewport center, +1 when above
    const center = rect.top + rect.height / 2;
    const progress = (viewH / 2 - center) / viewH;
    const maxShift = Math.min(48, rect.height * 0.12);
    const y = Math.max(-maxShift, Math.min(maxShift, progress * maxShift * 1.6));

    this.parallaxEl.style.transform = `translate3d(0, ${y.toFixed(2)}px, 0) scale(1.12)`;
  }
}

if (!customElements.get('article-hero')) {
  customElements.define('article-hero', ArticleHero);
}
